import LazyDisp from './lazydisp';
import Swiper from 'swiper/bundle';
// import FirstViewEndObserver from "../extended_class/FirstViewEndObserver";

const [d] = [document];

export default class COMMON {
  constructor(opt) {
    // settings
    this.opt = Object.assign({
      lazydisp: '[data-lazydisp]',
    }, opt);
	}
  init()
  {
    // イベント一覧
    d.addEventListener('Lazydisp.beforeInit', () => false);

		// イベント発火
    d.dispatchEvent(new CustomEvent('common.beforeInit', { detail: this }));
    this.LazyDisp = new LazyDisp(this.opt.lazydisp);
    // console.log(this.LazyDisp);

    const thumb = document.querySelectorAll(
        '[data-plugin="galleryThumb"] .thumb-media'
    );

    const switchThumb = (index) => {
        document
            .querySelector('[data-plugin="galleryThumb"] .thumb-media-active')
            .classList.remove('thumb-media-active');
        thumb[index].classList.add('thumb-media-active');
    };

    const mySwiper = new Swiper('[data-plugin="gallerySlider"]', {
        grabCursor: true,
        slidesPerView: 1,
        effect: 'slide',
        speed: 500,
        pagination: {
            el: '[data-plugin="gallerySlider"] .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            768: {
                spaceBetween: 0,
            },
        },
        on: {
            afterInit: (swiper) => {
                thumb[swiper.realIndex].classList.add('thumb-media-active');
                for (let i = 0; i < thumb.length; i++) {
                    thumb[i].onclick = () => {
                        swiper.slideTo(i);
                    };
                }
            },
            slideChange: (swiper) => {
                switchThumb(swiper.realIndex);
            },
        },
    });
	}

  domReady() {
    // console.log(`test`);
  }
}